/* jshint esversion: 6 */

// Recurly transaction errors only reach us as free text. These are the ones a
// different payment method would fix, as opposed to plan or validation errors.
export const isPaymentFailure = (message) =>
    /past due|expired|insufficient|transaction|decline/i.test(message || '');

// Recurly rejects a change identical to the subscription as it stands, which for
// an add-on update means the change already went through.
export const isNoOpChange = (message) =>
    /The submitted values match the current subscriptions values/.test(message || '');
